import { createBrowserHistory } from 'history'

export function goBack(history, fallbackLocation) {
  const browserHistory = createBrowserHistory()
  const customHistory = history === undefined ? browserHistory : history

  if (fallbackLocation) {
    customHistory.replace(fallbackLocation)
    return
  }

  if (customHistory.length > 1) {
    customHistory.goBack()
    return
  }

  customHistory.replace('/')
}
